import { render, staticRenderFns } from "./HostingPlan.vue?vue&type=template&id=03d7e78a&"
import script from "./HostingPlan.vue?vue&type=script&lang=js&"
export * from "./HostingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports